import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./ui/tabs";
import { PHRASE_LIBRARY, DISCIPLINE_LABEL } from "../data/phrases";
import { ChevronRight } from "lucide-react";

export default function PhraseLibrary({ defaultDiscipline = "OT", onUsePhrase }) {
  // Build the tab set: the user's own discipline first, then every other
  // discipline so they always have a fallback within reach. PHRASE_LIBRARY
  // has all 5 disciplines now (OT, ST, PT, COTA, PTA), so we show all five.
  const discTabs = (() => {
    const own = PHRASE_LIBRARY[defaultDiscipline] ? defaultDiscipline : null;
    const set = new Set();
    if (own) set.add(own);
    ["OT", "ST", "PT", "COTA", "PTA"].forEach((d) => {
      if (PHRASE_LIBRARY[d]) set.add(d);
    });
    return Array.from(set);
  })();
  const [active, setActive] = useState(discTabs[0]);

  return (
    <div data-testid="phrase-library-pane">
      <p className="text-sm uppercase tracking-[0.2em] text-zinc-500 mb-3">Phrase library</p>
      <Tabs value={active} onValueChange={setActive}>
        <TabsList className="grid w-full h-auto p-1" style={{ gridTemplateColumns: `repeat(${discTabs.length}, minmax(0, 1fr))` }}>
          {discTabs.map((d) => (
            <TabsTrigger
              key={d}
              value={d}
              className="h-11 text-sm data-[state=active]:bg-zinc-900 data-[state=active]:text-white"
              data-testid={`phrases-tab-${d}`}
            >
              {d}
            </TabsTrigger>
          ))}
        </TabsList>

        {discTabs.map((d) => (
          <TabsContent key={d} value={d} className="mt-4 space-y-4">
            <p className="text-xs text-zinc-500">{DISCIPLINE_LABEL[d]}</p>
            {Object.entries(PHRASE_LIBRARY[d] || {}).map(([cat, phrases]) => (
              <div key={cat}>
                <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">{cat}</p>
                <div className="space-y-1.5">
                  {phrases.map((p, i) => (
                    <button
                      key={`${d}-${cat}-${p}`}
                      onClick={() => onUsePhrase?.(p)}
                      className="w-full text-left px-3 py-3 rounded-lg border border-zinc-200 bg-white hover:bg-zinc-50 transition-colors duration-200 flex items-start gap-2 group"
                      data-testid={`phrase-${d}-${cat}-${i}`}
                    >
                      <ChevronRight className="w-4 h-4 mt-0.5 text-zinc-300 group-hover:text-zinc-700 shrink-0" />
                      <span className="text-sm text-zinc-800 leading-relaxed">{p}</span>
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
